import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconFeedbackAccordion = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={81}
    height={81}
    fill="none"
    viewBox="0 0 81 81"
    aria-hidden="true"
    {...props}
  >
    <g filter="url(#icon-feedback-accordion_svg__a)">
      <path
        fill="url(#icon-feedback-accordion_svg__b)"
        d="M41.125 40.5c2.25 0 4 1.875 4 4 0 2.25-1.75 4-4 4s-4-1.75-4-4c0-2.125 1.75-4 4-4Zm0-4c-1.625 0-3-1.25-3-3v-14c0-1.625 1.375-3 3-3s3 1.375 3 3v14c0 1.75-1.375 3-3 3Zm23.75-30c4.5 0 8 3.625 8 8v35.75c0 4.25-3.625 7.875-8 7.875h-18L31.25 69.875c-1 .625-2.375 0-2.375-1.25V58.25h-12c-4.5 0-8-3.5-8-7.875V14.5c0-4.375 3.5-8 8-8h48ZM67 50.5v-36c0-1-1-2-2-2H17c-1.125 0-2 1-2 2v36c0 1.125.875 2 2 2h18V60l10-7.5h20c1 0 2-.875 2-2Z"
      />
    </g>
    <defs>
      <linearGradient
        id="icon-feedback-accordion_svg__b"
        x1={73}
        x2={9}
        y1={6.5}
        y2={70.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF968D" />
        <stop offset={0.18} stopColor="#E2645A" />
        <stop offset={0.73} stopColor="#D83832" />
        <stop offset={1} stopColor="#AD3529" />
      </linearGradient>
      <filter
        id="icon-feedback-accordion_svg__a"
        width={90}
        height={90}
        x={-4}
        y={-4}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2243_46476"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_2243_46476"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_2243_46476"
          result="effect2_dropShadow_2243_46476"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_2243_46476"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
));
export default SvgIconFeedbackAccordion;
